export const STATUS_LABEL = {
  rascunho: "Rascunho",
  enviado: "Enviado",
  "1_aprovacao": "1 aprovação",
  aprovado: "Aprovado",
  rejeitado: "Rejeitado",
  cancelado: "Cancelado",
  pago: "Pago",
};

const STATUS_COLOR = {
  rascunho: "bg-slate-100 text-slate-700 border-slate-300",
  enviado: "bg-amber-50 text-amber-800 border-amber-300",
  "1_aprovacao": "bg-sky-50 text-sky-800 border-sky-300",
  aprovado: "bg-emerald-50 text-emerald-800 border-emerald-300",
  rejeitado: "bg-rose-50 text-rose-800 border-rose-300",
  cancelado: "bg-slate-100 text-slate-500 border-slate-300",
  pago: "bg-[#002776] text-white border-[#002776]",
};

export const CATEGORIES = [
  "Passagem aérea",
  "Hospedagem",
  "Transporte terrestre",
  "Refeição",
  "Combustível",
  "Material",
  "Outros",
];

export const fmtBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    Number(v) || 0
  );

export const INPUT_CLS =
  "mt-1 w-full border border-slate-300 px-3 py-2 rounded-sm disabled:bg-slate-50";

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`expense-status-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] uppercase tracking-wide border ${
        STATUS_COLOR[status] || "bg-slate-100"
      }`}
    >
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export const Field = ({ label, children }) => (
  <div>
    <label className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
      {label}
    </label>
    {children}
  </div>
);

export const Spinner = () => (
  <div className="p-8 text-center text-slate-500">
    <span className="inline-block w-4 h-4 mr-2 align-middle border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
    Carregando…
  </div>
);

export const downloadBlob = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
